/* Share buttons (snippets/share-links-bento.liquid): "copy link".

   `[data-share-copy]` holds the URL; a click writes it to the clipboard,
   marks the button for 2 s (`is-copied`) and announces it through the
   sibling `[data-share-copy-status]` (role="status"). Without the Clipboard
   API (an insecure context) the click does nothing. One delegated listener
   per page, however many snippets and scripts there are. */
(function () {
  if (window.LeonartoShare) return;
  window.LeonartoShare = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-share-copy]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.getAttribute('data-share-copy')).then(function () {
      var status = button.parentElement.querySelector('[data-share-copy-status]');
      button.classList.add('is-copied');
      if (status) status.textContent = status.getAttribute('data-message') || '';
      setTimeout(function () {
        button.classList.remove('is-copied');
        if (status) status.textContent = '';
      }, 2000);
    });
  });
})();
